/* eslint-disable no-console */
// utils/carteleria.js
import toast from "react-hot-toast"; // ← MANTENER
import { client, log } from ".";

export const getCostosHardware = async ({ pais, ano }) => {
  try {
    const { data: negocios, error: err1 } = await client
      .from("negocios_carteleria")
      .select("id")
      .eq("pais", pais)
      .neq("eliminada", true);
    if (err1) throw err1;
    if (!negocios?.length) return [];

    const negocioIds = negocios.map((n) => n.id);

    const { data, error: err2 } = await client
      .from("costos_carteleria_hardware")
      .select("negocio_id, mes, compra_hardware, otros_costos")
      .eq("ano", ano)
      .in("negocio_id", negocioIds);
    if (err2) throw err2;

    return data || [];
  } catch (error) {
    log.error("getCostosHardware", error);
    toast.error("Error cargando costos de hardware");
    throw error;
  }
};

export const upsertCostoHardware = async ({ negocio_id, ano, mes, compra_hardware = 0, otros_costos = 0 }) => {
  try {
    const { data, error } = await client.from("costos_carteleria_hardware").upsert(
      {
        negocio_id: Number(negocio_id),
        ano: Number(ano),
        mes: Number(mes),
        compra_hardware: Number(compra_hardware) || 0,
        otros_costos: Number(otros_costos) || 0,
      },
      { onConflict: "negocio_id,ano,mes" }
    );
    if (error) throw error;
    return data;
  } catch (error) {
    log.error("upsertCostoHardware", error);
    toast.error("Error guardando costo de hardware");
    throw error;
  }
};

// GET COSTOS FIJOS
export const getCostosFijos = async ({ pais, ano }) => {
  try {
    const { data, error } = await client.from("costos_fijos").select("*").eq("pais", pais).eq("ano", ano);

    if (error) throw error;
    return data || [];
  } catch (error) {
    log.error("getCostosFijos", error);
    toast.error("Error cargando costos fijos");
    throw error;
  }
};

// UPSERT COSTOS FIJOS
export const upsertCostosFijos = async (data) => {
  try {
    const { error } = await client.from("costos_fijos").upsert(data, { onConflict: "pais,ano,mes" });

    if (error) throw error;
  } catch (error) {
    log.error("upsertCostosFijos", error);
    toast.error("Error guardando costos fijos");
    throw error;
  }
};

// GET COSTOS GESTIÓN Y CONTENIDOS (con todas las columnas nuevas)
export const getCostosGestion = async ({ pais, ano }) => {
  try {
    const { data, error } = await client
      .from("costos_gestion_contenidos")
      .select(
        `
        id,
        negocio_id,
        ano,
        mes,
        software_ds,
        otros,
        pais,
        fecha_factura,
        factura_numero,
        valor_uf_usado
      `
      )
      .eq("pais", pais)
      .eq("ano", ano);

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error("Error en getCostosGestion:", error);
    toast.error("Error cargando costos de gestión");
    return [];
  }
};

// UPSERT COSTO GESTIÓN (con fecha_factura)
export const upsertCostoGestion = async ({
  negocio_id = null,
  pais,
  ano,
  mes,
  software_ds = 0,
  otros = 0,
  fecha_factura = null,
  factura_numero = null,
}) => {
  try {
    const { data, error } = await client
      .from("costos_gestion_contenidos")
      .upsert(
        {
          negocio_id: negocio_id ? Number(negocio_id) : null,
          pais,
          ano: Number(ano),
          mes: Number(mes),
          software_ds: Number(software_ds) || 0,
          otros: Number(otros) || 0,
          fecha_factura: fecha_factura || null,
          factura_numero: factura_numero || null,
        },
        { onConflict: "negocio_id,ano,mes" }
      )
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error("Error upsertCostoGestion:", error);
    toast.error("Error guardando costo de gestión");
    throw error;
  }
};

// NUEVA CARGA DE COSTOS HARDWARE (flexible)
export const getCostosHardwareFlex = async ({ pais, ano }) => {
  try {
    const { data, error } = await client
      .from("costos_hardware_flex")
      .select("*")
      .eq("pais", pais)
      .eq("ano", ano)
      .order("mes", { ascending: true });
    if (error) throw error;
    return data || [];
  } catch (error) {
    log.error("getCostosHardwareFlex", error);
    toast.error("Error cargando costos de hardware");
    return [];
  }
};

// GUARDAR / EDITAR COSTO
export const upsertCostoHardwareFlex = async ({
  id, // ← puede ser null o undefined
  negocio_id = null,
  pais,
  ano,
  mes,
  tipo,
  monto,
  descripcion = null,
}) => {
  try {
    const payload = {
      // NO mandes "id" en el payload cuando sea null/undefined
      ...(id && { id }), // solo incluye id si existe (para update)
      negocio_id: negocio_id || null,
      pais,
      ano: Number(ano),
      mes: Number(mes),
      tipo,
      monto: Number(monto) || 0,
      descripcion: descripcion || null,
    };

    const { data, error } = await client
      .from("costos_hardware_flex")
      .upsert(payload, {
        onConflict: "id",
        // importante: no usar .single() en insert, solo en update
      })
      .select()
      .maybeSingle(); // ← usa maybeSingle para que no falle si es insert

    if (error) throw error;
    return data;
  } catch (error) {
    log.error("upsertCostoHardwareFlex", error);
    toast.error("Error guardando costo");
    throw error;
  }
};

// ELIMINAR COSTO
export const deleteCostoHardwareFlex = async (id) => {
  try {
    const { error } = await client.from("costos_hardware_flex").delete().eq("id", id);
    if (error) throw error;
  } catch (error) {
    log.error("deleteCostoHardwareFlex", error);
    toast.error("Error eliminando costo");
    throw error;
  }
};
